import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Translate = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.08462 1.13466C6.36076 1.13466 6.58462 1.35852 6.58462 1.63466V2.74948H10C10.2761 2.74948 10.5 2.97333 10.5 3.24948C10.5 3.52562 10.2761 3.74948 10 3.74948H8.54669C8.4299 4.73132 7.95567 6.05406 7.08158 7.19516C6.96002 7.35385 6.8303 7.50955 6.69227 7.66077C7.42293 8.16843 8.32852 8.51565 9.33631 8.64718L10.6175 5.23069C10.6907 5.03554 10.8772 4.90625 11.0857 4.90625C11.2941 4.90625 11.4806 5.03554 11.5538 5.23069L14.4153 12.8612C14.5122 13.1197 14.3812 13.4079 14.1226 13.5049C13.8641 13.6018 13.5759 13.4708 13.4789 13.2123L12.6524 11.0081H9.51895L8.6924 13.2123C8.59544 13.4708 8.30724 13.6018 8.04868 13.5049C7.79012 13.4079 7.65911 13.1197 7.75607 12.8612L8.97716 9.60491C7.84661 9.42153 6.80052 8.99133 5.95023 8.35834C4.97856 9.13725 3.71279 9.67785 2.125 9.67785C1.84886 9.67785 1.625 9.45399 1.625 9.17785C1.625 8.9017 1.84886 8.67785 2.125 8.67785C3.38144 8.67785 4.39331 8.27999 5.19083 7.68244C4.5767 7.02741 4.13497 6.23211 3.93705 5.32479C3.8782 5.05499 4.0492 4.78856 4.319 4.72971C4.5888 4.67086 4.85522 4.84187 4.91407 5.11166C5.06965 5.82489 5.42515 6.46944 5.93316 7.00928C6.05879 6.87293 6.1769 6.73173 6.28772 6.58706C7.02787 5.6208 7.4212 4.52598 7.53789 3.74948H6.08462H2.14712C1.87098 3.74948 1.64712 3.52562 1.64712 3.24948C1.64712 2.97333 1.87098 2.74948 2.14712 2.74948H5.58462V1.63466C5.58462 1.35852 5.80848 1.13466 6.08462 1.13466ZM12.2774 10.0081L11.0857 6.83025L9.89395 10.0081H12.2774Z"
        fill={color}
      />
    </svg>
  )
})

export default Translate
